
export function calculateNextIndexWithinRange(indexDelta: number, currentIndex: number, length: number) {
	if (length <= 0) {
		throw new Error('length must be positive');
	}

	return (length + (currentIndex + indexDelta) % length) % length;
}
